/** `#ai` — `template.html` dòng 895–946, thuộc tính `data-en`. */

interface AgentType {
  readonly icon: 'globe' | 'user-round-cog' | 'users-round';
  readonly title: string;
  readonly body: string;
}

interface Capability {
  readonly icon: 'infinity' | 'user-plus';
  readonly title: string;
  readonly body: string;
}

interface SampleAgent {
  readonly initials: string;
  readonly name: string;
  readonly body: string;
  readonly chips: readonly string[];
}

const types: readonly AgentType[] = [
  {
    icon: 'globe',
    title: 'Public Agent',
    body: 'Shared across the whole company — one assistant everyone can use, with a single set of sources and rules.',
  },
  {
    icon: 'user-round-cog',
    title: 'Alias Agent',
    body: "A private assistant for each employee that inherits exactly that person's access rights — no more, no less.",
  },
  {
    icon: 'users-round',
    title: 'Department Agent',
    body: 'A public agent with a whitelist — only the listed users may call it, so finance, HR or legal assistants stay inside their department.',
  },
];

const capabilities: readonly Capability[] = [
  {
    icon: 'infinity',
    title: 'Unlimited connectors & skills',
    body: "Any external system with an API can be connected, and skills can be added without limit — so an agent's capability grows with the company instead of being fixed at launch.",
  },
  {
    icon: 'user-plus',
    title: 'Guest role',
    body: 'Bring partners and contractors into the workspace as Guests. A member adds them to a channel or group, where they can work with the team — and chat with the agents in that channel.',
  },
];

const samples: readonly SampleAgent[] = [
  {
    initials: 'HR',
    name: 'Hera HR',
    body: 'Policies, leave, onboarding checklists.',
    chips: ['HRIS', 'Docs'],
  },
  {
    initials: 'AD',
    name: 'Atlas DevOps',
    body: 'Pipelines, deploys, incident timelines.',
    chips: ['CI/CD', 'GitLab'],
  },
  {
    initials: 'PS',
    name: 'Pitch Sales',
    body: 'Pipeline health, account briefs, follow-ups.',
    chips: ['CRM'],
  },
  {
    initials: 'CR',
    name: 'Clio Research',
    body: 'Market scans and sourced summaries.',
    chips: ['Web'],
  },
  {
    initials: 'FE',
    name: 'Forge Engineer',
    body: 'Code review notes, tickets, technical drafts.',
    chips: ['Repo', 'Linear'],
  },
  {
    initials: 'QA',
    name: 'Quill Analyst',
    body: 'Dashboards, SQL answers, go/no-go calls.',
    chips: ['SQL', 'Snowflake'],
  },
];

export const aiAgents = {
  eyebrow: 'AI Agents & Skills',
  heading: 'Unlimited agents, scoped the way your company is scoped.',
  lead: 'A company can deploy as many agents as it needs — company-wide, per employee, or per department — and every agent lives in the same threads as the team, so an answer becomes a task without leaving the conversation.',
  types,
  capabilities,
  samplesEyebrow: 'Example agents in the demo workspace',
  samples,
  skillsLabel: 'Skills',
  skillsBody:
    'Reusable skills carry your process, wording and guardrails — write one, share it across every agent type.',
};
